import { EventEmitter } from '@angular/core';
import * as THREE from 'three';
import { FikoThreeJsComponent } from '../fiko-three-js.component';
import { FikoRaycastConfigService } from '../services/fiko-raycast-config.service';

export class FikoRaycastCPUYardimci {
    raycaster = new THREE.Raycaster();
    mouse = { x: Infinity, y: Infinity };
    mouseVektor = new THREE.Vector3();
    yon = new THREE.Vector3();
    //---> RS+: Seçim Falan Filan
    public odaktakiler: THREE.Intersection[] = [];
    //---> RS+: Change Olaylarını Free Etmek İçin
    haritaOlaylar: Map<string, any> = new Map();
    //---> RS+: Yakalandı Olayları
    kontrolBasili: boolean = false;
    odakDuraklat: boolean = false;
    ortaTusBasili: boolean = false;
    uzerinde: EventEmitter<THREE.Intersection> = new EventEmitter<any>();
    tiklandi: EventEmitter<THREE.Intersection> = new EventEmitter<any>();

    constructor(
        public anaGosterim: FikoThreeJsComponent,
        public rayObje: any,
        public filitreler: any[] | "*",
        public odakAktif: boolean = false,
        private raycastConfigService?: FikoRaycastConfigService
    ) {
        // Raycast config servisi varsa, merkezi ayarlarını kullan
        if (this.raycastConfigService) {
            this.raycaster.params = this.raycastConfigService.getRaycastParams();
            // Config değişikliklerine abone ol
            this.raycastConfigService.config$.subscribe(config => {
                this.raycaster.params = this.raycastConfigService!.getRaycastParams();
                // Raycast config değiştiğinde odaktaki listeyi temizle (yeni threshold'larla yeniden hesaplansın)
                this.odaktakiler = [];
            });
        } else {
            // Fallback: Varsayılan ayarlar
            // 🎯 IMPROVED: Çizgi ve nokta seçim hassasiyeti artırıldı
            this.raycaster.params = {
                Mesh: { threshold: 0.2 },
                Line: { threshold: 2.0 },      // 0.2 → 1.5 (7.5x daha kolay seçim)
                LOD: { threshold: 0.3 },
                Points: { threshold: 0.2 },    // 0.2 → 2.0 (10x daha kolay seçim)
                Sprite: { threshold: 0.1 }
            }
        }
    }

    baslat() {
        // this.bitir();
        this.haritaOlaylar.set(
            "pointermove",
            this.anaGosterim.renderer.listen(this.anaGosterim.canvas.nativeElement, "pointermove", ($event: any) => {
                this.onPointerMove($event);
            })
        );

        this.haritaOlaylar.set(
            "pointerdown",
            this.anaGosterim.renderer.listen(this.anaGosterim.canvas.nativeElement, "pointerdown", ($event: any) => {
                this.odakDuraklat = true;
                this.onPointerDown($event);
            })
        );

        this.haritaOlaylar.set(
            "pointerup",
            this.anaGosterim.renderer.listen(this.anaGosterim.canvas.nativeElement, "pointerup", ($event: any) => {
                // Orta tuş bırakıldığında state'i sıfırla
                if ($event.button === 1) {
                    this.ortaTusBasili = false;
                }

                if ($event.buttons == 0) {
                    this.odakDuraklat = false;
                }
                // this.onPointerUp($event);
            })
        );

        // this.haritaOlaylar.set(
        //     "click",
        //     this.anaGosterim.renderer.listen(this.anaGosterim.canvas.nativeElement, "click", ($event: any) => {
        //         this.odakDuraklat = true;
        //         this.onClick($event);
        //     })
        // );

    }

    bitir() {
        this.haritaOlaylar.forEach((value: any, key: string) => {
            if (value) value();
        });
        this.uzerinde.complete();
        this.tiklandi.complete();
        this.uzerinde = new EventEmitter();
        this.tiklandi = new EventEmitter();
    }

    bitirUzerinde() {
        this.uzerinde.complete();
        this.uzerinde = new EventEmitter();
    }

    bitirTiklandi() {
        this.tiklandi.complete();
        this.tiklandi = new EventEmitter();
    }

    // t = new THREE.Clock();
    onPointerMove(event: any) {
        // if (this.t.getDelta() < 0.2) return;

        // Orta tuş basılı ise raycast'ı devre dışı bırak
        if (event.buttons === 4 || this.ortaTusBasili) {
            return;
        }

        this.mouse.x = (event.offsetX) / (this.anaGosterim.canvas.nativeElement.clientWidth) * 2 - 1;
        this.mouse.y = - (event.offsetY / this.anaGosterim.canvas.nativeElement.clientHeight) * 2 + 1;

        if (!this.odakAktif) return;

        this.uzerindeRaycast();
    }

    onPointerDown($event: PointerEvent) {
        // Orta tuş (button 1) basılı ise takip et
        if ($event.button === 1) {
            this.ortaTusBasili = true;
            return;
        }

        if ($event.buttons == 1) {
            this.kontrolBasili = $event.ctrlKey;
            this.tiklandiRaycast();
            this.kontrolBasili = false;
        }
    }

    onClick($event: PointerEvent) {
        if ($event.buttons == 1) {
            this.kontrolBasili = $event.ctrlKey;
            this.tiklandiRaycast();
            this.kontrolBasili = false;
        }
    }


    // onPointerUp($event: PointerEvent) {

    // }

    // 🎯 Piksel → dünya birimi eşik dönüşümü (FikoSecililer.dinamikRaycastEsikleriUygula ile aynı
    // mantık): config'teki Line/Points eşikleri piksel niyetli — THREE dünya birimi kullanır.
    private dinamikEsikUygula(): void {
        const kamera: any = this.anaGosterim?.aktifKamera;
        const canvas = this.anaGosterim?.canvas?.nativeElement;
        const p: any = this.raycaster?.params;
        if (!kamera || !canvas || !p) return;
        const h = canvas.clientHeight || 1;
        let wpp: number;
        if (kamera.isOrthographicCamera || kamera.top !== undefined) {
            wpp = Math.abs((kamera.top - kamera.bottom) / (kamera.zoom || 1)) / h;
        } else {
            const hedef = this.anaGosterim?.aktifKontrol?.target;
            const dist = hedef ? kamera.position.distanceTo(hedef) : kamera.position.length();
            wpp = (2 * Math.max(0.001, dist) * Math.tan((kamera.fov || 50) * Math.PI / 360)) / h;
        }
        if (!isFinite(wpp) || wpp <= 0) return;
        const cfg = this.raycastConfigService?.getConfig?.();
        if (p.Line) p.Line.threshold = Math.max(5, cfg?.lineThreshold ?? 10) * wpp;
        if (p.Points) p.Points.threshold = Math.max(8, cfg?.pointsThreshold ?? 8) * wpp;
    }

    tiklandiRaycast() {
        this.mouseVektor.set(this.mouse.x, this.mouse.y, -1);
        this.mouseVektor.unproject(this.anaGosterim.aktifKamera);
        this.yon.set(0, 0, -1).transformDirection(this.anaGosterim.aktifKamera.matrixWorld);
        this.raycaster.set(this.mouseVektor, this.yon);
        this.dinamikEsikUygula();

        if (this.rayObje)
            if (Array.isArray(this.rayObje))
                this.odaktakiler = this.raycaster.intersectObjects(this.rayObje, true);
            else
                this.odaktakiler = this.raycaster.intersectObject(this.rayObje, true);
        else
            this.odaktakiler = this.raycaster.intersectObjects(this.anaGosterim.sahneler[0].children, true);

        let odaktaki = this.odaktakiler[0];

        if (odaktaki) {
            if (this.rayObje)
                if (!Array.isArray(this.rayObje))
                    //@ts-ignore
                    if (!(odaktaki.index >= odaktaki.object.geometry.drawRange.start && odaktaki.index <= (odaktaki.object.geometry.drawRange.start) + odaktaki.object.geometry.drawRange.count))
                        return;

            // ÖNEMLI: Points seçiminde closestPointIndex ekle
            if (odaktaki.object.type === "Points") {
                const e = odaktaki.object as THREE.Points;
                const intersectionPoint = odaktaki.point?.clone() || new THREE.Vector3();
                const invMatrix = new THREE.Matrix4().copy((e as any).matrixWorld || (e.parent as any)?.matrixWorld || new THREE.Matrix4()).invert();
                intersectionPoint.applyMatrix4(invMatrix);

                const positions = (e.geometry as THREE.BufferGeometry).attributes["position"];
                let minDist = Infinity;
                let closestIndex = 0;

                const ipx = intersectionPoint.x, ipy = intersectionPoint.y, ipz = intersectionPoint.z;
                for (let i = 0; i < positions.count; i++) {
                    const dx = positions.getX(i) - ipx;
                    const dy = positions.getY(i) - ipy;
                    const dz = positions.getZ(i) - ipz;
                    const distSq = dx * dx + dy * dy + dz * dz;
                    if (distSq < minDist) {
                        minDist = distSq;
                        closestIndex = i;
                    }
                }
                (odaktaki as any).closestPointIndex = closestIndex;
            }

            if (this.filitreler !== "*")
                if (this.filitreler.indexOf(odaktaki.object.type) > -1) {
                    this.tiklandi.emit(odaktaki);
                } else {
                    this.tiklandi.emit();
                }
            else
                this.tiklandi.emit(odaktaki)
        } else {
            this.tiklandi.emit();
        }
    }

    private lastMove = Date.now();
    uzerindeDuraklama = 0; // 🚀 Throttle removed - WASM caching handles performance
    uzerindeRaycast() {
        if (this.odakDuraklat) return;
        // 🚀 OPTIMIZATION: Throttle removed for smooth 60 FPS interaction
        // WASM caching absorbs redundant raycast queries automatically
        if (this.uzerindeDuraklama > 0 && Date.now() - this.lastMove < this.uzerindeDuraklama) {
            return;
        } else {
            this.lastMove = Date.now();
        }

        this.mouseVektor.set(this.mouse.x, this.mouse.y, -1);
        this.mouseVektor.unproject(this.anaGosterim.aktifKamera);
        this.yon.set(0, 0, -1).transformDirection(this.anaGosterim.aktifKamera.matrixWorld);
        this.raycaster.set(this.mouseVektor, this.yon);
        this.raycaster.camera = this.anaGosterim.aktifKamera
        this.dinamikEsikUygula();
        
        if (this.rayObje)
            if (Array.isArray(this.rayObje))
                this.odaktakiler = this.raycaster.intersectObjects(this.rayObje, true);
            else
                this.odaktakiler = this.raycaster.intersectObject(this.rayObje, true);
        else
            this.odaktakiler = this.raycaster.intersectObjects(this.anaGosterim.sahneler[0].children, true);

        let odaktaki = this.odaktakiler[0];


        if (odaktaki) {
            // console.log(odaktaki)
            if (this.rayObje)
                if (!Array.isArray(this.rayObje))
                    //@ts-ignore
                    if (!(odaktaki.index >= odaktaki.object.geometry.drawRange.start && odaktaki.index <= (odaktaki.object.geometry.drawRange.start) + odaktaki.object.geometry.drawRange.count))
                        return;


            if (this.filitreler !== "*")
                if (this.filitreler.indexOf(odaktaki.object.type) > -1) {
                    this.uzerinde.emit(odaktaki);
                } else {
                    this.uzerinde.emit();
                }
            else
                this.uzerinde.emit(odaktaki)
        } else {
            this.uzerinde.emit();
        }
    }

    dispose() {
        this.haritaOlaylar.forEach((value: any, key: string) => {
            if (value) value();
        });
        this.bitir();
    }

}